"use strict";
exports.__esModule = true;
exports.SvgFilter = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgFilter = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 14" }, props),
    react_1["default"].createElement("g", { fill: "none", fillRule: "evenodd" },
        react_1["default"].createElement("path", { fill: "currentColor", fillRule: "nonzero", d: "M12.069 1c.475 0 .866.355.924.814l.007.117v1.892a.929.929 0 01-.157.518l-.085.109-3.379 3.715v3.18c0 .41-.197.674-.598.836l-.142.05-.141.039-2.946.73a.93.93 0 01-.924-.814l-.007-.117V8.166L1.242 4.45a.944.944 0 01-.21-.382l-.022-.107L1 3.823V1.931c0-.475.355-.866.814-.924L1.931 1h10.138zm-.521 1.5H2.5v1.162l3.567 3.923.054.14-.001 3.582 1.76-.393v-3.19l.054-.14 3.614-3.923V2.5z" }),
        react_1["default"].createElement("path", { d: "M0 0h14v14H0z" })))); };
//# sourceMappingURL=Filter.js.map